import React from "react";
import { CalendarClock, MapPin, Clock } from "lucide-react";
import { meetings } from "../mock";

const Meetings = () => {
  return (
    <section
      id="stretnutia"
      className="bg-campaign-cream py-16 sm:py-24 px-4 sm:px-6 border-t-4 border-campaign-ink"
    >
      <div className="max-w-4xl mx-auto">
        <div className="inline-flex items-center gap-2 bg-campaign-coral text-campaign-cream font-bold uppercase text-xs px-3 py-1.5 border-2 border-campaign-ink -rotate-1 mb-4">
          <CalendarClock size={16} /> {meetings.subheading}
        </div>
        <h2 className="font-display text-4xl sm:text-6xl text-campaign-ink leading-none uppercase">
          {meetings.heading}
        </h2>
        <p className="mt-4 text-campaign-ink/80 text-base sm:text-lg max-w-2xl">
          {meetings.intro}
        </p>

        <ul className="mt-10 space-y-3">
          {meetings.events.map((e, i) => (
            <li
              key={i}
              className={`flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 border-4 border-campaign-ink p-4 shadow-brutal hover-lift ${
                e.highlight ? "bg-campaign-coral" : "bg-campaign-yellow"
              }`}
            >
              <span
                className={`shrink-0 font-display text-base sm:text-lg px-3 py-1.5 border-2 border-campaign-ink ${
                  e.highlight ? "bg-campaign-cream text-campaign-ink" : "bg-campaign-blue text-campaign-cream"
                }`}
              >
                {e.date}
              </span>
              <span className="flex-1 flex items-start gap-2 min-w-0">
                <MapPin size={18} className={`mt-1 shrink-0 ${e.highlight ? "text-campaign-cream" : "text-campaign-coral"}`} />
                <span className={`font-semibold ${e.highlight ? "text-campaign-cream" : "text-campaign-ink"}`}>
                  <span className="font-display uppercase">{e.place}</span>
                  {e.venue ? <span className="text-base">: {e.venue}</span> : null}
                </span>
              </span>
              <span className={`shrink-0 inline-flex items-center gap-1.5 font-display ${e.highlight ? "text-campaign-cream" : "text-campaign-ink"}`}>
                <Clock size={16} /> {e.time}
              </span>
            </li>
          ))}
        </ul>

        <p className="mt-8 text-campaign-ink/70 text-sm">
          Zmeny termínov vyhradené. Sledujte náš web a sociálne siete pre aktuálne informácie.
        </p>
      </div>
    </section>
  );
};

export default Meetings;
